import { create } from "zustand";

interface SmartTrawlState {
  isRunning: boolean;
  isCompleted: boolean;
  error: string | null;
  progress: {
    currentPaper: string;
    current: number;
    total: number;
    totalAdded: number;
    step: string;
  };

  start: (total: number) => void;
  updateProgress: (update: Partial<SmartTrawlState["progress"]>) => void;
  complete: (totalAdded: number) => void;
  fail: (error: string) => void;
  reset: () => void;
}

const INITIAL_PROGRESS = { currentPaper: "", current: 0, total: 0, totalAdded: 0, step: "" };

export const useSmartTrawlStore = create<SmartTrawlState>((set) => ({
  isRunning: false,
  isCompleted: false,
  error: null,
  progress: { ...INITIAL_PROGRESS },

  start: (total) =>
    set({ isRunning: true, isCompleted: false, error: null, progress: { ...INITIAL_PROGRESS, total } }),

  updateProgress: (update) =>
    set((s) => ({ progress: { ...s.progress, ...update } })),

  complete: (totalAdded) =>
    set((s) => ({
      isRunning: false,
      isCompleted: true,
      progress: { ...s.progress, totalAdded },
    })),

  fail: (error) =>
    set({ isRunning: false, error }),

  reset: () =>
    set({ isRunning: false, isCompleted: false, error: null, progress: { ...INITIAL_PROGRESS } }),
}));
